import React from 'react';
import Icon from '../../../components/AppIcon';

const RecentActivityList = ({ activities = [] }) => {
  const getActivityIcon = (type) => {
    const iconMap = {
      create: 'Plus',
      update: 'Edit2',
      delete: 'Trash2',
      view: 'Eye',
      upload: 'Upload'
    };
    return iconMap?.[type] || 'Activity';
  };

  const getActivityColor = (type) => {
    const colorMap = {
      create: 'text-success',
      update: 'text-primary',
      delete: 'text-error',
      view: 'text-secondary',
      upload: 'text-accent'
    };
    return colorMap?.[type] || 'text-text-secondary';
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 60) return `${diffMins} minutes ago`;
    if (diffHours < 24) return `${diffHours} hours ago`;
    if (diffDays < 7) return `${diffDays} days ago`;
    return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  if (activities?.length === 0) {
    return (
      <div className="text-center py-12">
        <Icon name="Activity" size={48} className="text-text-secondary mx-auto mb-4 opacity-50" />
        <p className="text-text-secondary">No recent activity</p>
      </div>
    );
  }

  return (
    <div className="space-y-1">
      {activities?.map((activity) => (
        <div
          key={activity?.id}
          className="flex items-start gap-4 p-4 rounded-lg hover:bg-muted transition-colors duration-150"
        >
          <div className={`p-2 rounded-lg bg-background ${getActivityColor(activity?.type)}`}>
            <Icon name={getActivityIcon(activity?.type)} size={16} />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm text-text-primary font-medium">{activity?.title}</p>
            <p className="text-xs text-text-secondary mt-1">{activity?.description}</p>
          </div>
          <span className="text-xs text-text-secondary whitespace-nowrap">
            {formatTimestamp(activity?.timestamp)}
          </span>
        </div>
      ))}
    </div>
  );
};

export default RecentActivityList;